export const types = <const>{
	actions: {
		ZAKAZNICKA_SKUPINA_CHANGE: 'zakaznickaSkupinaChange',
		FAKTURACNI_PROFIL_CHANGE: 'fakturacniProfilChange',
		VOZIDLO_CHANGE: 'VozidloChange',
		ZAKAZNIK_CHANGE: 'ZakaznikChange',
		PROVOZOVNA_CHANGE: 'provozovnaChange',
		SMLUVNI_PARTNER_CHANGE: 'SmluvniPartnerChange',
		SMLUVNI_PARTNER_TYP_CHANGE: 'smluvniPartnerTypChange',
		POJISTOVNA_CHANGE: 'PojistovnaChange',
		LEASING_CHANGE: 'LeasingChange',
		JINY_PRIJEMCE_CHANGE: 'JinyPrijemceChange',
		INTERNI_ZAKAZNICKA_SKUPINA_CHANGE: 'interniZakaznickaSkupinaChange',
		INTERNI_FAKTURACNI_PROFIL_CHANGE: 'interniFakturacniProfilChange',
		INTERNI_DRUH_CHANGE: 'interniDruhChange',
		LOAD_PACKETS: 'LoadPackets',
		SLEVA_CHANGE: 'slevaChange',
		GET_DMZ_CDB: 'GetCdbDzmStatus',
		CDB_PREPAID_SERVICE: 'cdbPrepaidService',
		ZAKAZNIK_CDB_STATUS: 'GetCdbCustomerRecordStatus',
		GET_DMZ: 'getDMZ',
		ZAKAZKA_PNV_CHANGE: 'ZAKAZKA_PNV_CHANGE',
		ZAKAZKA_POV_CHANGE: 'ZAKAZKA_POV_CHANGE',
		ZAKAZKA_NV_CHANGE: 'ZAKAZKA_NV_CHANGE',
		ZAKAZKA_OV_CHANGE: 'ZAKAZKA_OV_CHANGE',
		ZAKAZKA_NVSKLAD_CHANGE: 'ZAKAZKA_NVSKLAD_CHANGE',
		LOAD_MDV_VOZIDLO: 'loadMdvVozidlo',
		LOAD_MDV_PNV: 'loadMdvPnv',
		GET_FAKTURACNI_PODILY: 'getPodily',
		INT_PODIL_CHANGE: 'zmenaIntPodil',
		ZAK_PODIL_CHANGE: 'zmenaZakPodil',
		UPRAVA_POLOZKY_CHECK: 'upravaPolozkyCheck',
		NABIDKA_NA_PRIPRAVU_CHANGE: 'prevedNabidkuDoPripravy',
		PRIPRAVA_NA_OTEVRENOU_CHANGE: 'prevodOtevrena',
		UVOLNENA_NA_OTEVRENOU_CHANGE: 'UvolnenaToOtevrena',
		CHANGE_TO_KULANCE: 'changeToKulance',
		CHANGE_TO_GARANCE: 'changeToGarance',
		CHANGE_TO_INTERNI: 'changeToInterni',
		VEHICLE_INFORMATION_CHECK: 'vehicleInformationCheck',
		PRINT_VYDEJKA_ND: 'printVydejkaNd',
		GET_JDNF_COUT: 'getJdnfCount',
		GET_PAKETY_COUT: 'getPaketyCount',
		PRINT_ADVANCE_RECEIPT: 'getAdvancePayReceipt',
		CANCEL_SERVICE_PACKAGE: 'CancelServicePackage',
		ZAKAZNIK_FIRST_VISIT_CHECK: 'ZAKAZNIK_FIRST_VISIT_CHECK',
		GET_CAMPAIGN_DETAILS: 'GET_CAMPAIGN_DETAILS',		
	},
	mutations: {
		SERVICE_PACKAGE: 'SERVICE_PACKAGE',
		SHOW_ITN_CARD: 'SHOW_ITN_CARD',
		SET_ZAKAZKA_CHECKBOX_FILTERS: 'setZakazkaCheckboxFilters',
		ZAKAZNIK_CDB: 'ZAKAZNIK_CDB',
		ZAKAZKA_PRACOVNIK_SELECT_MAPPER: 'ZAKAZKA_PRACOVNIK_SELECT_MAPPER',
		ZAKAZKA_LAK_DRUH_SELECT_MAPPER: 'ZAKAZKA_LAK_DRUH_SELECT_MAPPER',
		ZAKAZKA_ZAKAZNIK_SELECT_MAPPER: 'ZAKAZKA_ZAKAZNIK_SELECT_MAPPER',
		ZAKAZKA_SMLUVNI_PARTNER_SELECT_MAPPER: 'ZAKAZKA_SMLUVNI_PARTNER_SELECT_MAPPER',
		ZAKAZKA_POJISTOVNA_SELECT_MAPPER: 'ZAKAZKA_POJISTOVNA_SELECT_MAPPER',
		ZAKAZKA_LEASING_SELECT_MAPPER: 'ZAKAZKA_LEASING_SELECT_MAPPER',
		ZAKAZKA_JINY_PRIJEMCE_SELECT_MAPPER: 'ZAKAZKA_JINY_PRIJEMCE_SELECT_MAPPER',
		ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER: 'ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER',
		ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER: 'ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER',
		ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER: 'ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER',
		ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER: 'ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER',
		ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER: 'ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER',
		ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER: 'ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER',
		ZAKAZKA_REF_SELECT_MAPPER: 'ZAKAZKA_REF_SELECT_MAPPER',
		ZAKAZKA_VOZIDLO_SELECT_MAPPER: 'ZAKAZKA_VOZIDLO_SELECT_MAPPER',
		ZAKAZKA_INTER_DRUH_SELECT_MAPPER: 'ZAKAZKA_INTER_DRUH_SELECT_MAPPER',
		ZAKAZKA_PNV_SELECT_MAPPER: 'ZAKAZKA_PNV_SELECT_MAPPER',
		ZAKAZKA_POV_SELECT_MAPPER: 'ZAKAZKA_POV_SELECT_MAPPER',
		ZAKAZKA_NV_SELECT_MAPPER: 'ZAKAZKA_NV_SELECT_MAPPER',
		ZAKAZKA_OV_SELECT_MAPPER: 'ZAKAZKA_OV_SELECT_MAPPER',
		ZAKAZKA_NVSKLAD_SELECT_MAPPER: 'ZAKAZKA_NVSKLAD_SELECT_MAPPER',
		LOAD_MDV_VOZIDLO: 'LOAD_MDV_VOZIDLO',
		LOAD_MDV_PNV: 'LOAD_MDV_PNV',
		ZAKAZKA_MIO_SELECT_MAPPER: 'ZAKAZKA_MIO_SELECT_MAPPER',
		ZAKAZKA_ADD_FAKT_TEXT: 'ZAKAZKA_ADD_FAKT_TEXT',
		ZAKAZKA_RESET_SELECTED_TAB: 'ZAKAZKA_RESET_SELECTED_TAB',
		ZAKAZKA_UPRAVA_POLOZKY: 'ZAKAZKA_UPRAVA_POLOZKY',
		ZAKAZKA_KALKULACE_STREDNAKL_SELECT: 'ZAKAZKA_KALKULACE_STREDNAKL_SELECT',
		ZAKAZKA_KALKULACE_PRACOVNIK_SELECT: 'ZAKAZKA_KALKULACE_PRACOVNIK_SELECT',
		CHECK_IN_SELECT: 'checkInSelect',
		SET_KALKULACE_TABLE_SCHEMA_AND_ROWS: 'setKalkulaceTableSchemaAndRows',
		SET_CAR_DESCRIPTION: 'setCarDescription',
		SET_TISK_DIALOG: 'setTiskDialog',
		ZAKAZNIK_CUSTOMER_FIRST_VISIT: 'ZAKAZNIK_CUSTOMER_FIRST_VISIT',
		GET_CUSTOMER_CAMPAIGN_DETAILS: 'GET_CUSTOMER_CAMPAIGN_DETAILS',
	},
};

export type ElsaRExternalUrls = { App:string, Available:Boolean, Url:string };
